import { Box, styled } from '@mui/material';

export const ActionBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginLeft: '50%',
  width: '50%',
  justifyContent: 'space-evenly',
  gap: theme.spacing(5),
  padding: `0 ${theme.spacing(5)}`,
  '&>*': {
    flex: 1
  }
}));
